import React, { useState, useEffect  } from 'react';

const BlocksSelector = (props) => {

  const [blocks] = useState(props.blocks)

  useEffect(() => {
    const canvas = document.getElementById("blockSelectorCanvas")
    if (canvas) {
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = "#00000055"
      ctx.fillRect(0, 0, props.width, props.height);
      for (let i = 0; i < props.blocks.length; i++) {
        const block = props.blocks[i];
        ctx.clearRect(block.left - canvas.offsetLeft, block.top - canvas.offsetTop, block.width, block.height);
      }
    }
  });

  const onClick = (e) => {
    const x = e.clientX 
    const y = e.clientY
    for (let i = 0; i < props.blocks.length; i++) {
      const block = props.blocks[i];
      if (x >= block.left && y >= block.top && x <=block.left + block.width && y <= block.top + block.height) {
        props.onSelect(block)
        return
      }
    }
    props.onSelect(undefined)
  }

  return <canvas id="blockSelectorCanvas" style={props.style} width={props.width} height={props.height} onClick={onClick}/>
}

export default BlocksSelector
